import { SearchOutlined } from '@ant-design/icons';
import { useTranslation } from '@framework/i18n';
import { Button, Space } from 'antd';
import { FilterConfirmProps } from 'antd/es/table/interface';
import React from 'react';
import styled from 'styled-components';

const ButtonHalfSpace = styled(Button)`
  width: 90px;
`;

export interface ITableColumnFilterButtonsProps {
  clearFilters: (() => void) | undefined;
  confirm: (param?: FilterConfirmProps | undefined) => void;
}

/**
 * Centralizzazione dei pulsanti per i filtri delle colonne delle tabelle. (conferma e reset)
 */
export function TableColumnFilterButtons(
  props: ITableColumnFilterButtonsProps,
) {
  const { clearFilters, confirm } = props;
  const { t } = useTranslation();

  return (
    <Space size={8}>
      <ButtonHalfSpace
        onClick={() => {
          clearFilters?.();
          confirm({ closeDropdown: true });
        }}
        size="small"
      >
        {t('table.table-column-filter-buttons.reset', 'Reset')}
      </ButtonHalfSpace>
      <ButtonHalfSpace
        type="primary"
        onClick={() => {
          confirm({ closeDropdown: true });
        }}
        icon={<SearchOutlined />}
        size="small"
      >
        {t('table.table-column-filter-buttons.search', 'Cerca')}
      </ButtonHalfSpace>
    </Space>
  );
}
